import type { CatalogueListing } from "../../api/catalogue";

/** "1 pc", "3 pcs", "2 m". Items sold by length are sold in whole metres. */
export const quantityUnit = (unit: CatalogueListing["unit"], quantity: number) => (unit === "metre" ? "m" : quantity === 1 ? "pc" : "pcs");
